
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.666 6.259V8.31a3.31 3.31 0 002.702-3.248 3.309 3.309 0 00-3.305-3.305 3.309 3.309 0 00-3.305 3.305A3.31 3.31 0 005.459 8.31V6.26a1.34 1.34 0 01.604-2.537 1.34 1.34 0 01.603 2.537z"}}),_c('path',{attrs:{"d":"M6.063 0a5.063 5.063 0 00-.937 10.038.654.654 0 01.333-.339v-.743a3.945 3.945 0 01-3.335-3.893 3.944 3.944 0 013.939-3.94 3.944 3.944 0 013.939 3.94 3.945 3.945 0 01-3.336 3.893v.743a.654.654 0 01.334.339A5.063 5.063 0 006.063 0z"}}),_c('path',{attrs:{"d":"M6.423 9.966H6.35V5.407l.5.179-.763-1.244-.81 1.244.5-.179v4.559h-.074a.306.306 0 00-.241.123.37.37 0 00-.077.228V12l.658-.701.7.701v-1.683a.371.371 0 00-.077-.228.307.307 0 00-.242-.123z"}})])
          )
        }
      }
    